import React from "react";
import CategoryPage from "./CategoryPage";

function PressRelease({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Press Release"
      parentCategory="News"
      posts={posts}
      publications={publications}
    />
  );

}

export default PressRelease;